import * as helpers from "./helpers";

const types = helpers.createActionTypes("global", ["ADD_ALERT", "REMOVE_ALERT", "CLEAN_ALERTS"]);

export default types;
